import { create, windowedFiniteBatchScheduler } from "@yornaath/batshit";
import apiClient from "services/ApiClient";
import { createQueryString } from "helpers/queryString";
import { NewHireJourneyId } from "models/newHire";
import { Task } from "./models";

// Custom resolver that works with keyed object responses
const keyedObjectResolver = (key: string) => (
  items: Record<NewHireJourneyId, Task[]>,
  query: { newHireJourneyId: NewHireJourneyId },
) => {
  const journeyId = String(query[key]);
  return items[journeyId] || [];
};

const tasksByJourneyBatcher = create({
  fetcher: async (queries: { newHireJourneyId: NewHireJourneyId }[]): Promise<Record<NewHireJourneyId, Task[]>> => {
    const journeyIds = queries.map((query) => query.newHireJourneyId);
    const queryString = createQueryString({
      additionalQueries: {
        new_hire_journey_ids: journeyIds,
      },
    });

    // Backend returns { data: { "123": [...], "456": [...] } }
    const response = await apiClient.performRequest<{ data: Record<NewHireJourneyId, Task[]> }>(
      `/api/new-hire-journeys/tasks/batch?${queryString}`,
    );

    return response.payload.data;
  },
  resolver: keyedObjectResolver("newHireJourneyId"),
  scheduler: windowedFiniteBatchScheduler({
    windowMs: 10, // Batch requests within 10ms window
    maxBatchSize: 5, // Limit to 10 journeys per request for performance
  }),
});

export default tasksByJourneyBatcher;
